<template>
<div class="chapter">
<div class="inner_page">
<p class="p2"><span class="sz"> </span></p>
<p class="p2"><span class="sz"> </span></p>
<p class="p3"><span class="sz">This book, finally, is for Kristine</span></p>
<p class="p3"><span class="sz">—unbeknownst to herself,</span></p>
<p class="p3"><span class="sz">a kind of Beatrice</span></p>
<p class="p4"><span class="sz"> </span></p>
<p class="p3"><span class="sz">1951–1971</span></p>
<p class="p5"><span class="sz"> </span></p>
<p class="p2"><span class="sz"><b></b> </span></p>
<p class="p2"><span class="sz"><b></b> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?2e8fb133